import * as React from 'react';
import { render } from 'react-dom';

import { IDropdownMenuLink, IDropdownMenuProps } from './dropdown_menu';
import { IDropdownMenuData, TDropdownType } from './interfaces';
import { getLinks } from './links';

let DropDownMenu: React.ComponentClass<IDropdownMenuProps>;

const getAlwaysOpened = (data: IDropdownMenuData, name: TDropdownType): boolean => {
  switch (name) {
    case 'rent':
      return data.isRentPage;
    case 'sale':
      return data.isSalePage;
    case 'newbuildings':
      return data.isNewBuildingsPage;
    case 'commercial':
      return data.isCommercialPage;
    default:
      throw new Error('unknown dropdown menu type');
  }
};

export const dropdownMenuRender = (
  containerElement: Element,
  parentElement: Element,
  data: IDropdownMenuData,
  name: TDropdownType,
) => {
  try {
    const container = document.createElement('div');
    const links: IDropdownMenuLink[] = getLinks(data, name);
    const alwaysOpened: boolean = getAlwaysOpened(data, name);
    const hideShadow: boolean = alwaysOpened && (name == 'sale' || name == 'rent');

    if (!links.length) {
      return;
    }

    containerElement.appendChild(container);

    if (!DropDownMenu) {
      require.ensure(['./dropdown_menu'], () => {
        DropDownMenu = require('./dropdown_menu').default;

        render(
          <DropDownMenu parentElement={parentElement} links={links} alwaysOpened={alwaysOpened} hideShadow={hideShadow} />,
          container
        );
      });
    } else {
      render(
        <DropDownMenu parentElement={parentElement} links={links} alwaysOpened={alwaysOpened} hideShadow={hideShadow} />,
        container
      );
    }
  } catch (e) { }
}



// WEBPACK FOOTER //
// ./src/bundles/header/components/dropdown_menu/index.tsx